// extracted by mini-css-extract-plugin
export default {"middleSection":"MiddleSection-module__middleSection__rnVlX"};